import {
  Box,
  Accordion,
  Typography,
  AccordionSummary,
  Stack,
  AccordionDetails,
} from '@mui/material';

import INSPECTION_TYPES from '@/components/inspectionTypes';
import RunningInspectionDocumentChecks from './RunningInspectionDocumentChecks';
import type { Inspection } from '@/types/apiTypes';

interface RunningInspectionProps {
  inspection: Inspection & {
    type: INSPECTION_TYPES;
    documents?: Array<{
      document_id?: string;
      document_name?: string;
      [key: string]: unknown;
    }>;
    [key: string]: unknown;
  };
}

function RunningInspection({
  inspection,
}: RunningInspectionProps): React.JSX.Element {
  return (
    <Box sx={{ width: '100%' }}>
      {(inspection.type === INSPECTION_TYPES.EFFECTIVE
        ? inspection.documents || []
        : [{}]
      ).map((document) => {
        return (
          <Accordion key={document.document_id || 'draft_document'} expanded>
            {document.document_name ? (
              <AccordionSummary>
                <Stack direction='row' spacing={2} alignItems={'center'}>
                  <Typography variant='h6' gutterBottom>
                    {document.document_name}
                  </Typography>
                </Stack>
              </AccordionSummary>
            ) : undefined}
            <AccordionDetails>
              <RunningInspectionDocumentChecks
                inspection={inspection}
                document={document}
              />
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
}

export default RunningInspection;

